module.exports = __webpack_public_path__ + "media/images/pic/lectors/dorota-rybinska-7e51f9ea9e2662cedc1e461fcb3ca310.jpeg";